<template>
  <div class="sidebar">
    <el-menu
      :default-active="activeMenu"
      router
      :collapse="collapse"
      :collapse-transition="false"
      class="sidebar-menu"
    >
      <el-menu-item index="/">
        <el-icon><Histogram /></el-icon>
        <template #title>股票统计</template>
      </el-menu-item>

      <el-menu-item index="/stcok-case">
        <el-icon><Files /></el-icon>
        <template #title>股票案例</template>
      </el-menu-item>

      <el-menu-item index="/stcok-action">
        <el-icon><Operation /></el-icon>
        <template #title>股票操作</template>
      </el-menu-item>

      <el-menu-item index="/stcok-article">
        <el-icon><Document /></el-icon>
        <template #title>李剑文章</template>
      </el-menu-item>

      <el-menu-item index="/stcok-compounding">
        <el-icon><TrendCharts /></el-icon>
        <template #title>复利力量</template>
      </el-menu-item>

      <el-menu-item index="/stcok-fortune">
        <el-icon><MagicStick /></el-icon>
        <template #title>算命复利</template>
      </el-menu-item>

      <!-- 系统管理 -->
      <el-sub-menu v-if="systemMenus.length" index="system">
        <template #title>
          <el-icon><Setting /></el-icon>
          <span>系统管理</span>
        </template>

        <el-menu-item
          v-for="item in systemMenus"
          :key="item.path"
          :index="item.path"
        >
          <el-icon><component :is="item.icon" /></el-icon>
          <template #title>{{ item.label }}</template>
        </el-menu-item>
      </el-sub-menu>
    </el-menu>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import {
  Histogram,
  Files,
  Operation,
  Document,
  TrendCharts,
  MagicStick,
  Setting,
  User,
  Menu,
  Avatar,
  OfficeBuilding
} from '@element-plus/icons-vue'

defineProps({
  // 是否折叠（由父级 App.vue 传入）
  collapse: {
    type: Boolean,
    default: false
  }
})

const route = useRoute()
const store = useStore()

const activeMenu = computed(() => route.path)

// 系统管理菜单（按权限过滤）
const systemMenus = computed(() => {
  const hasPermission = store.getters['user/hasPermission']

  const menus = [
    { path: '/system/user', label: '用户管理', icon: User, permission: 'sys:user:list' },
    { path: '/system/role', label: '角色管理', icon: Avatar, permission: 'sys:role:list' },
    { path: '/system/menu', label: '菜单管理', icon: Menu, permission: 'sys:menu:list' },
    { path: '/system/dept', label: '部门管理', icon: OfficeBuilding, permission: 'sys:dept:list' }
  ]

  return menus.filter(item => hasPermission(item.permission))
})
</script>

<style lang="less" scoped>
.sidebar {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 10px 0;

  // 深色侧边栏滚动条
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 2px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

.sidebar-menu {
  border: none;
  background: transparent;
  padding: 0 10px;

  // ===== 菜单项基础 =====
  :deep(.el-menu-item),
  :deep(.el-sub-menu__title) {
    position: relative;
    height: 46px;
    line-height: 46px;
    margin-bottom: 4px;
    padding: 0 12px !important;
    border-radius: 10px;
    color: rgba(255, 255, 255, 0.68);
    font-size: 14px;
    font-weight: 500;
    overflow: hidden;
    transition: background 0.22s ease, color 0.22s ease,
      transform 0.22s ease;

    .el-icon {
      margin-right: 10px;
      font-size: 17px;
      color: rgba(255, 255, 255, 0.55);
      transition: color 0.22s ease, transform 0.22s ease;
    }

    // 悬停
    &:hover {
      background: rgba(255, 255, 255, 0.08);
      color: #fff;

      .el-icon {
        color: #fff;
        transform: scale(1.08);
      }
    }

    // 选中
    &.is-active {
      color: #fff;
      font-weight: 600;
      background: linear-gradient(135deg, #409eff 0%, #2d7dd2 100%);
      box-shadow: 0 6px 18px rgba(64, 158, 255, 0.4);

      .el-icon {
        color: #fff;
      }

      // 左侧高亮竖条
      &::before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 20px;
        border-radius: 0 2px 2px 0;
        background: #fff;
        box-shadow: 0 0 10px rgba(255, 255, 255, 0.9);
      }
    }
  }

  // ===== 子菜单展开区域 =====
  :deep(.el-sub-menu .el-menu) {
    background: rgba(0, 0, 0, 0.12);
    border-radius: 10px;
    padding: 4px;

    .el-menu-item {
      height: 42px;
      line-height: 42px;
      font-size: 13px;
      margin-bottom: 2px;
    }
  }

  :deep(.el-sub-menu.is-active > .el-sub-menu__title) {
    color: #fff;

    .el-icon {
      color: #fff;
    }
  }

  // ===== 折叠态 =====
  &.el-menu--collapse {
    padding: 0 8px;

    :deep(.el-menu-item),
    :deep(.el-sub-menu__title) {
      justify-content: center;
      padding: 0 !important;

      .el-icon {
        margin-right: 0;
      }

      &.is-active::before {
        display: none;
      }
    }
  }
}
</style>